// PollView.jsx

import React, { useEffect, useState } from 'react';

// Context
import { useUser } from 'context/UserContext';

// Services
import { hasUserVotedOnPoll } from 'services/polls/PollReadService';

// CSS
import './PollView.css';

// Components
import PollResults from '../results/PollResults';
import PollVote from '../vote/PollVote';

/**
 * PollView
 * 
 * Displays a poll feed item.
 * 
 * @param {object} node - Node containing the poll item widget.
 *  
 *
 * @returns {ReactNode} - PollView component.
 */
const PollView = ({ node }) => {

    // ----- CONTEXT ----- //

    // Global Context

    const { user } = useUser();

    // ----- STATE ----- //

    // Local state

    const [hasVoted, setHasVoted] = useState(false);
    const [voteLoaded, setVoteLoaded] = useState(false);

    // ----- EFFECTS ----- //

    /**
     * Check if this user has already voted on this poll node.
     */

    useEffect(() => {
        const checkVote = async () => {
            if (!user?.key || !node?.key) return;

            try {
                const voted = await hasUserVotedOnPoll(node.key, user.key);
                if (voted) setHasVoted(true);
            } catch (err) {
                console.error('Failed to check vote:', err);
            } finally {
                setVoteLoaded(true);
            }
        };

        checkVote();
    }, [node?.key, user?.key]);

    // ----- HANDLERS ----- //

    /**
 * Handles vote.
 *
 * @param {*} index
 */

    const handleVote = (index) => {
        setHasVoted(true); // immediately switch to results view
    };

    // ----- RENDER ----- //

    return (
        <div className="poll-view-container">

            {/* INNER */}
            <div className="poll-view-inner">

                {!voteLoaded && (
                    <div className="poll-view-loading-placeholder">Loading poll...</div>
                )}

                {voteLoaded && hasVoted && (
                    <PollResults
                        node={node}
                    />
                )}

                {voteLoaded && !hasVoted && (
                    <PollVote
                      node={node}
                      onVote={handleVote}
                    />
                )}

            </div>

        </div>
    );
};

// Dev Tools
PollView.displayName = 'PollView';

export default PollView;
